import { Component, OnInit, Input } from '@angular/core';
import { FooterKnowMoreService } from './footer-know-more.service';
import { Router } from '@angular/router';
import { CreateAccount } from 'app/shared/objects/account';

@Component({
  selector: 'ma-footer-know-more',
  templateUrl: './footer-know-more.component.html',
  styleUrls: ['./footer-know-more.component.scss']
})
export class FooterKnowMoreComponent implements OnInit {

  public form: CreateAccount = new CreateAccount;

  @Input() cityId: string = null;
  constructor(
    private footerKnowMoreService: FooterKnowMoreService,
    public router: Router
  ) { }

  ngOnInit(): void { }

  go() {
    window.scrollTo(0, 0);
  }
  onSubmit() {
    window.scrollTo(0, 0);
    this.router.navigate(['/create-account', { name: this.form.name, email: this.form.email, cityId: this.cityId }]);
  }

}
